import withEditarResumenProfesional from "../../hoc/Docentes/withEditarResumenProfesional";
import EditarPerfilProfesional from "../../view/components/RegistroUsuarios/PerfilProfesional/EditarCv/EditarCv";

export default withEditarResumenProfesional(EditarPerfilProfesional);